import { required, confirmed, email, regex } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import i18n from './i18n';

extend("required", {
    ...required,
    message: i18n.t('app.components.general.field-is-required')
});

extend("email", {
    ...email,
    message: i18n.t('app.components.general.invalid-email-format')
});

extend("confirmed", {
    ...confirmed,
    message: i18n.t('app.components.signup.confirm-pasword-error')
});

extend("password", {
    ...regex,
    message: i18n.t('app.components.signup.password-regex-text')
})